/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { renderRequiredMessage } from "../utils/render-required-message";
import { TrFun } from "../utils/types";
import { GeneralFieldController } from "./general-field-controller";
import { UnitedResponseType } from "../models/generated/graphql";
import { getEnumValues } from "../utils/get-enum-values";

export class ResultFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translate: TrFun): Yup.AnySchema {
		return super.createFieldValidationRuleByDataType(translate).when(AttributeIdentifiers.ResponseReceived, {
			is: true,
			then: (s) => s.required(renderRequiredMessage(AttributeIdentifiers.Result, translate)),
		});
	}

	override useControlProps(): FlexControlProps {
		const [responseReceived] = useFieldValue(AttributeIdentifiers.ResponseReceived);
		const { t } = useTranslation();
		const options = getEnumValues(UnitedResponseType)
			.filter((response) => response !== UnitedResponseType.NoInfo)
			.map((v) => ({
				label: t(v),
				value: v,
			}));

		return {
			controlType: "combo",
			options,
			disabled: !responseReceived,
		};
	}
}
